import DOMController from "./abstract/DOMController";
import { triggerCustomEvent } from "./EventTrigger";

export default class Tabs extends DOMController
{
    protected controls: NodeListOf<HTMLElement>;
    protected classes = {
        active: 'tabs-control_active',
        hidden: 'display_none',
    }

    constructor(controls: string|NodeListOf<HTMLElement>)
    {
        super();

        this.controls = typeof controls === 'string' ? document.querySelectorAll(controls) : controls;
    }

    public init()
    {
        this.appendEventListeners();
    }

    public switchTab(control: HTMLElement)
    {
        let activeControl = null;
        let activeTarget = null;

        this.controls.forEach(item => {
            let tabId = item.dataset.tabId;
            let tab = document.getElementById(tabId);

            if (control.dataset.tabId === tabId) {
                this.activateControl(item);
                this.showTab(tab);
                
                activeControl = item;
                activeTarget = tab;
            } else {
                this.deactivate(item);
                this.hideTab(tab);
            }
        });

        if (activeControl !== null) {
            triggerCustomEvent(activeControl, 'tabs.after.switch', {detail: {target: activeTarget}});
        }
    }

    /**
     * 
     * @param id 
     * @return HTMLElement|null
     */
    public getControlByTabId(id: string)
    {
        let result = null;

        this.controls.forEach(control => {
            if (control.dataset.tabId === id) {
                result = control;
            }
        });

        return result;
    }

    /**
     * 
     * @param control 
     * @return HTMLElement
     */
    public getTabByControl(control: HTMLElement)
    {
        return document.getElementById(control.dataset.tabId);
    }

    public list(): NodeListOf<HTMLElement>
    {
        return this.controls;
    }

    protected appendEventListeners()
    {
        this.controls.forEach(control => {
            control.addEventListener('click', () => {
                this.switchTab(control);
            });
        });
    }

    protected activateControl(item: Element)
    {
        item.classList.add(this.classes.active);
    }

    protected deactivate(item: Element)
    {
        item.classList.remove(this.classes.active);
    }

    protected deactivateAll()
    {
        this.controls.forEach(control => {
            this.deactivate(control);
        });
    }

    public isActive(item: Element): boolean
    {
        if (item.classList.contains(this.classes.active)) {
            return true;
        }

        return false;
    }

    protected showTab(tab: Element)
    {
        if (tab !== null) {
            tab.classList.remove(this.classes.hidden);
        }
    }

    protected hideTab(tab: Element)
    {
        if (tab !== null) {
            tab.classList.add(this.classes.hidden);
        }
    }
}
